/**
 * Clases CSS compartidas del dispositivo Nutri-Matic.
 * Fuente visual: src/styles/nutrimatic/device.css
 */
export const nutrimaticDevice = {
  console: 'nutrimatic-console',
  /** Móvil: consola a pantalla completa (no flota en la página). */
  consoleImmersive: 'nutrimatic-console--immersive',
  consoleFixedViewport: 'nutrimatic-console--fixed-viewport',
  consoleBody: 'nutrimatic-console__body',
  viewportHost: 'nutrimatic-viewport-host',
  viewport: 'nutrimatic-viewport',
  viewportChrome: 'nutrimatic-viewport__chrome',
  viewportLcd: 'nutrimatic-viewport__lcd',
  viewportLcdLocked: 'nutrimatic-viewport__lcd--locked',
  /** Única zona con scroll táctil dentro del LCD (overscroll contenido). */
  viewportScroll: 'nutrimatic-viewport__scroll',
  modeDeck: 'nutrimatic-mode-deck',
  modeDeckLocked: 'nutrimatic-mode-deck--locked',
  modeDeckBtn: 'nutrimatic-mode-deck__btn',
  status: 'nutrimatic-status',
  /** Ranura inset del bezel — envuelve cada módulo (selection, readout, dispenser). */
  bay: 'nutrimatic-bay',
  /** @deprecated Alias de `bay`. */
  selection: 'nutrimatic-bay',
  readout: 'nutrimatic-readout',
  readoutChart: 'nutrimatic-readout-chart',
  readoutStructured: 'nutrimatic-readout--structured',
  readoutPairTrigger: 'nutrimatic-readout__pair-trigger',
  readoutDisplaySurface: 'nutrimatic-readout-display',
  readoutDisplayChart: 'nutrimatic-readout-display__chart',
  readoutDisplayIntel: 'nutrimatic-readout-display__intel',
  readoutDisplayMessage: 'nutrimatic-readout-display__message',
  readoutDisplayGrid: 'nutrimatic-readout-display__grid',
  readoutDisplayGridMarketOnly: 'nutrimatic-readout-display__grid--market-only',
  readoutDisplayConsole: 'nutrimatic-readout-display__console',
  readoutDisplayMetrics: 'nutrimatic-readout-display__metrics',
  readoutDisplayMetricsColCompact: 'nutrimatic-readout-display__metrics-col--compact',
  readoutDisplayMetricsColQuotes: 'nutrimatic-readout-display__metrics-col--quotes',
  readoutDisplayFooter: 'nutrimatic-readout-display__footer',
  readoutDisplayFooterBar: 'nutrimatic-readout-display__footer-bar',
  readoutDisplayTimeframe: 'nutrimatic-readout-display__timeframe',
  readoutDisplayTimeframeBtn: 'nutrimatic-readout-display__timeframe-btn',
  readoutSpotQuote: 'nutrimatic-readout-spot-quote',
  readoutSpotQuoteFooter: 'nutrimatic-readout-spot-quote--footer',
  readoutSpotQuoteDetail: 'nutrimatic-readout-spot-quote__detail',
  readoutSpotQuoteInvert: 'nutrimatic-readout-spot-quote__invert',
  readoutSpotQuoteLines: 'nutrimatic-readout-spot-quote__lines',
  readoutSpotQuoteSecondaryRow: 'nutrimatic-readout-spot-quote__secondary-row',
  readoutSpotQuoteSecondary: 'nutrimatic-readout-spot-quote__secondary',
  readoutSpotQuoteUsdPrimary: 'nutrimatic-readout-spot-quote__usd-primary',
  readoutSpotQuoteDisplayToggle: 'nutrimatic-readout-spot-quote__display-toggle',
  readoutDisplaySlot: 'nutrimatic-readout-display__slot',
  readoutDisplaySlotLabel: 'nutrimatic-readout-display__slot-label',
  readoutDisplaySlotValue: 'nutrimatic-readout-display__slot-value',
  /** @deprecated Usar readoutDisplay*. */
  readoutChartSlot: 'nutrimatic-readout-chart-slot',
  readoutConsole: 'nutrimatic-readout-console',
  readoutConsolePrompt: 'nutrimatic-readout-console__prompt',
  readoutConsoleMetrics: 'nutrimatic-readout-console__metrics',
  readoutConsoleCell: 'nutrimatic-readout-console__cell',
  readoutContextSlot: 'nutrimatic-readout-context',
  readoutContextFooter: 'nutrimatic-readout-context__footer',
  /** LCD central desktop: altura fija compartida entre cotización y transacción. */
  viewportDisplay: 'nutrimatic-viewport-display',
  /** Bahía combinada de montos + acción (variante synthesis). */
  synthesisDeck: 'nutrimatic-synthesis-deck',
  synthesisDeckLanes: 'nutrimatic-synthesis-deck__lanes',
  synthesisDeckInvert: 'nutrimatic-synthesis-deck__invert',
  synthesisDeckActions: 'nutrimatic-synthesis-deck__actions',
  /** Núcleo de síntesis montado directo sobre la consola (sin bay ni fondo). */
  synthesisSurface: 'nutrimatic-synthesis-surface',
  /** Cartucho activo — par cargado + saldos + selección de leg. */
  patchStrip: 'nutrimatic-patch-strip',
  patchStripLanes: 'nutrimatic-patch-strip__lanes',
  patchStripLeg: 'nutrimatic-patch-strip__leg',
  patchStripLegActive: 'nutrimatic-patch-strip__leg--active',
  patchStripLegLabel: 'nutrimatic-patch-strip__leg-label',
  patchStripLegToken: 'nutrimatic-patch-strip__leg-token',
  patchStripLegBalance: 'nutrimatic-patch-strip__leg-balance',
  patchStripLegBalanceIcon: 'nutrimatic-patch-strip__leg-balance-icon',
  patchStripInvert: 'nutrimatic-patch-strip__invert',
  patchStripLibrary: 'nutrimatic-patch-strip__library',
  /** Zona desktop: scope (readout) + perform (trade). */
  deviceScope: 'nutrimatic-device-scope',
  devicePerform: 'nutrimatic-device-perform',
  performBay: 'nutrimatic-perform-bay',
  performBayFooter: 'nutrimatic-perform-bay__footer',
  mobileSwapStack: 'nutrimatic-mobile-swap-stack',
  mobileSwapScope: 'nutrimatic-mobile-swap-stack__scope',
  mobileSwapPerform: 'nutrimatic-mobile-swap-stack__perform',
  mobileSwapPerformExpanded: 'nutrimatic-mobile-swap-stack__perform--expanded',
  synthesisInstrument: 'nutrimatic-synthesis-instrument',
  synthesisInstrumentHeader: 'nutrimatic-synthesis-instrument__header',
  synthesisInstrumentLegs: 'nutrimatic-synthesis-instrument__legs',
  synthesisInstrumentLeg: 'nutrimatic-synthesis-instrument__leg',
  synthesisInstrumentLegRow: 'nutrimatic-synthesis-instrument__leg-row',
  synthesisInstrumentLegToken: 'nutrimatic-synthesis-instrument__leg-token',
  synthesisInstrumentLegBalance: 'nutrimatic-synthesis-instrument__leg-balance',
  synthesisInstrumentLegBalanceIcon: 'nutrimatic-synthesis-instrument__leg-balance-icon',
  synthesisInstrumentLegSwitch: 'nutrimatic-synthesis-instrument__leg-switch',
  synthesisInstrumentLegAsset: 'nutrimatic-synthesis-instrument__leg-asset',
  synthesisInstrumentFooter: 'nutrimatic-synthesis-instrument__footer',
  synthesisInstrumentChannels: 'nutrimatic-synthesis-instrument__channels',
  synthesisInstrumentLanes: 'nutrimatic-synthesis-instrument__lanes',
  synthesisInstrumentSlot: 'nutrimatic-synthesis-instrument__slot',
  synthesisInstrumentSlotActive: 'nutrimatic-synthesis-instrument__slot--active',
  synthesisInstrumentSlotGlyph: 'nutrimatic-synthesis-instrument__slot-glyph',
  synthesisInstrumentSlotLed: 'nutrimatic-synthesis-instrument__slot-led',
  synthesisInstrumentSlotLabel: 'nutrimatic-synthesis-instrument__slot-label',
  synthesisInstrumentSlotAsset: 'nutrimatic-synthesis-instrument__slot-asset',
  synthesisInstrumentSlotPreview: 'nutrimatic-synthesis-instrument__slot-preview',
  synthesisInstrumentSlotPreviewActive: 'nutrimatic-synthesis-instrument__slot-preview--active',
  synthesisInstrumentSlotBalance: 'nutrimatic-synthesis-instrument__slot-balance',
  synthesisInstrumentSlotBalanceIcon: 'nutrimatic-synthesis-instrument__slot-balance-icon',
  synthesisInstrumentSlotBalanceValue: 'nutrimatic-synthesis-instrument__slot-balance-value',
  synthesisInstrumentInvert: 'nutrimatic-synthesis-instrument__invert',
  synthesisInstrumentEditor: 'nutrimatic-synthesis-instrument__editor',
  synthesisInstrumentEditorInput: 'nutrimatic-synthesis-instrument__editor-input',
  synthesisInstrumentEditorCaret: 'nutrimatic-synthesis-instrument__editor-caret',
  synthesisInstrumentEditorBalance: 'nutrimatic-synthesis-instrument__editor-balance',
  synthesisInstrumentLcd: 'nutrimatic-synthesis-instrument__lcd',
  synthesisInstrumentTelemetry: 'nutrimatic-synthesis-instrument__telemetry',
  synthesisInstrumentTelemetryGrid: 'nutrimatic-synthesis-instrument__telemetry-grid',
  synthesisInstrumentTelemetryIdle: 'nutrimatic-synthesis-instrument__telemetry-idle',
  synthesisInstrumentAction: 'nutrimatic-synthesis-instrument__action',
  dispenser: 'nutrimatic-dispenser',
  /** Superficie de trabajo plana dentro del módulo (displays montados encima). */
  panelSurface: 'nutrimatic-panel-surface',
  /** Display LCD / LED montado sobre el panel. */
  display: 'nutrimatic-display',
  displayScreen: 'nutrimatic-display__screen',
  displayLabel: 'nutrimatic-display__label',
  /** Identidad del token pintada directo sobre el LCD (sin badge). */
  displayAsset: 'nutrimatic-display__asset',
  displayValueRow: 'nutrimatic-display__value-row',
  displayReadout: 'nutrimatic-display__readout',
  displayReadoutLabel: 'nutrimatic-display__readout-label',
  displayReadoutValue: 'nutrimatic-display__readout-value',
  /** Input numérico montado sobre pantalla LCD (sin ring del sitio). */
  lcdInput: 'nutrimatic-lcd-input',
  displayPresets: 'nutrimatic-display__presets',
  tokenBadge: 'nutrimatic-token-badge',
  /** Botón físico raised (switch, toggles). */
  physicalButton: 'nutrimatic-physical-btn',
  /** Franja de controles físicos sobre la consola (ajustes, temporalidad, switch). */
  controlStrip: 'nutrimatic-control-strip',
  physicalSelector: 'nutrimatic-physical-selector',
  physicalSelectorBtn: 'nutrimatic-physical-selector__btn',
  physicalSelectorBtnActive: 'nutrimatic-physical-selector__btn--active',
  /** Panel interactivo de acción + opciones contextuales. */
  controlDeck: 'nutrimatic-control-deck',
  controlDeckOptions: 'nutrimatic-control-deck__options',
  readoutCell: 'nutrimatic-readout-cell',
  actionPrimary: 'nutrimatic-action-primary',
  actionSecondary: 'nutrimatic-action-secondary',
} as const

export type NutrimaticDeviceClass = (typeof nutrimaticDevice)[keyof typeof nutrimaticDevice]
